const fmt = (d) => (d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '')

const SECTIONS = [
  ['Chief Complaints', 'chiefComplaint'], ['HOPI', 'hopi'], ['Past History', 'pastHistory'],
  ['Other Relevant Information', 'otherInfo'], ['Physical Examination', 'physicalExam'],
  ['General Examination', 'generalExam'], ['A. Teeth / Alveolar process', 'teethNotes'],
  ['B. Periodontium', 'periodontium'], ['C. Oral Mucous Membrane', 'oralMucosa'], ['D. TMJ', 'tmj'],
  ['Diagnosis', 'diagnosis']
]

/** Read-only body of one saved EMR; shared by the history panel and the print sheet. */
export function EmrSummary({ emr, deptName, findingName }) {
  return (
    <div className="emr-summary">
      {SECTIONS.map(([label, key]) => emr[key] ? (
        <div className="sum-row" key={key}><b>{label}</b><span>{emr[key]}</span></div>
      ) : null)}
      {emr.teeth?.length > 0 && (
        <div className="sum-row"><b>Teeth (Palmer)</b>
          <span>{emr.teeth.map((t) => `${t.palmerCode} – ${findingName(t.findingCode)}${t.note ? ' (' + t.note + ')' : ''}`).join('; ')}</span></div>
      )}
      {emr.referrals?.length > 0 && (
        <div className="sum-row"><b>Referral</b>
          <span>{emr.referrals.map((r, i) => `${i + 1}. ${deptName(r.deptCode)} (${r.deptCode})`).join('  →  ')}</span></div>
      )}
    </div>
  )
}

/**
 * Past visits for the patient. Props: history (array of saved EMRs), currentVisitId,
 * deptName(code), findingName(code), onClose, onCopy(emr) - optional "copy to current sheet"
 */
export default function HistoryPanel({ history, currentVisitId, deptName, findingName, onClose, onCopy }) {
  const past = history.filter((h) => h.visitId !== currentVisitId)
  return (
    <div className="drawer">
      <div className="drawer-head">
        <b>Past visits ({past.length})</b>
        <button type="button" onClick={onClose}>✕</button>
      </div>
      {past.length === 0 && <div className="muted" style={{ padding: 10 }}>No previous dental visits recorded.</div>}
      <div className="drawer-body">
        {past.map((h) => (
          <details key={h.dentalEmrId} className="visit">
            <summary>
              <span className="vdate">{fmt(h.visitDate)}</span>
              <span className="vdx">{h.diagnosis || h.chiefComplaint || '—'}</span>
              <span className="muted">Visit #{h.visitId}</span>
            </summary>
            <EmrSummary emr={h} deptName={deptName} findingName={findingName} />
            {onCopy && <div className="row-end"><button type="button" onClick={() => onCopy(h)}>Copy findings to current sheet</button></div>}
          </details>
        ))}
      </div>
    </div>
  )
}

export { fmt }
